import {Component, Input, OnInit} from '@angular/core';
import {Paths} from '../../../config/config';

@Component({
  selector: 'app-box-news-in-evidence',
  templateUrl: './box-news-in-evidence.component.html'
})
export class BoxNewsInEvidenceComponent implements OnInit {

  @Input() title;
  @Input() slug;
  @Input() description;
  @Input() date;
  @Input() img;

  public readonly PathNews = Paths.NewsSingle;

  ngOnInit() {
  }
}
